
const CLICK_MAGICK_SCRIPT_ID = 'clickmagick-cmc-script'

let initialized = false

declare global {
  interface Window {
    clickmagick_cmc?: {
      uid: string
      hid: string
      cmc_project: string
      vid_info: 'on' | 'off'
      utm_source: string
    }
  }
}

/**
 * Loads ClickMagick campaign tracking once for the current visitor.
 */
export function initClickMagick(): void {
  if (initialized || typeof window === 'undefined') return

  window.clickmagick_cmc = {
    uid: '213029',
    hid: '1629707996',
    cmc_project: 'Proyecto Joint Genesis',
    vid_info: 'on',
    utm_source: 'organic',
  }

  if (!document.getElementById(CLICK_MAGICK_SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = CLICK_MAGICK_SCRIPT_ID
    script.async = true
    script.src = '//track.jointgenesis369.com/affe6e82.js'
    document.head.appendChild(script)
  }

  initialized = true
}

/**
 * Destination for the final CTA. ClickMagick registers the action and then
 * handles the redirect to the vendor via its own cmc_redir parameter.
 */
export const OFFER_URL =
  'https://jointgenesis369.com?cmc_goal=a&cmc_ref=sawoffer&cmc_redir=https%3A%2F%2F533e6fn7n1cy9rdhzbpph3yze8.hop.clickbank.net%3Ftid%3D%5Bcmc_vid%5D'
